import { useCallback, useState } from 'react'
import type { PickerTab } from './MediaPicker'

/**
 * Панель гифок, стикеров и эмодзи под полем ввода. Кнопка открывает свою вкладку,
 * нажатие на другую переключает, повторное на ту же — закрывает. Как в Discord.
 */
export function usePicker() {
  const [tab, setTab] = useState<PickerTab | null>(null)
  const toggle = useCallback((next: PickerTab) => setTab((cur) => (cur === next ? null : next)), [])
  const close = useCallback(() => setTab(null), [])
  return { tab, toggle, select: setTab, close }
}
